export default "__VITE_ASSET__CgPBjMxR__"